// components/create-station/station-menu/station-menu.component.jsx
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useCollabProjects } from "../../collab-projects/CollabProjectsProvider";
import Views from "../../views/views.component";
import TopBarRow from "../../ui-elements/top-bar-row/top-bar-row.component";
import StationInfo from "../../station-info/station-info.component";
import Filter from "../../filter/filter-component";
import ProjectMembersButton from "../../members/ProjectMembersButton";
import { BsFunnel, BsFunnelFill, BsSearch } from "react-icons/bs";
import { IoCloseOutline } from "react-icons/io5";
import "./station-menu.styles.scss";

const StationMenu = ({ station }) => {
  const stationData = useSelector(state => state.space.stationData) || [];
  const assignedTasks = useSelector(state => state.tasks.tasks) || [];
  const projectTasks = useSelector(state => state.prjtasks.prjtasks) || [];
  const projectNotes = useSelector(state => state.prjnotes.prjnotes) || [];
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [, , currentSpaceId, , currentStationId, view] = pathname.split("/");
  const { spaces } = useCollabProjects();
  const workspace = spaces.find(space => (space.spaceId || space.id) === currentSpaceId);
  const data = station || stationData.find(item => item.stationId === currentStationId && (item.spaceId || item.fromSpaceId) === currentSpaceId);
  const [showFilters, setShowFilters] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const matches = item => String(item.title || "").toLowerCase().includes(searchValue.toLowerCase());
  const matchingTasks = projectTasks.filter(matches);
  const otherTasks = assignedTasks.filter(matches).filter(task => task.fromStationId !== currentStationId || task.fromSpaceId !== currentSpaceId);
  const matchingNotes = projectNotes.filter(matches);
  const result = (item, path) => <button key={path} type="button" className="sm__search-result" onClick={() => { setShowSearchBar(false); navigate(path); }}>{item.title}</button>;

  return <div className="stationMenu">
    <TopBarRow className="sm__upperRow">
      <div className="sm__rowcontent">
        <div className="sm__identity">
          <StationInfo data={data} workspace={workspace} currentStationId={currentStationId} currentSpaceId={currentSpaceId} />
          <ProjectMembersButton spaceId={currentSpaceId} stationId={currentStationId} toolbar />
        </div>
        <div className="filterandsearch_container">
          <div className="filterandsearch">
            <div className="searchbar_container">
              <button type="button" className={showSearchBar ? "sm__filters-toggle-active" : "sm__filters-toggle"}
                aria-label="Search project" aria-expanded={showSearchBar}
                onClick={() => { setShowSearchBar(!showSearchBar); setShowFilters(false); }}><BsSearch size="1.3em" /></button>
              {showSearchBar && <div className="sm__search-panel" onKeyDown={event => { if (event.key === "Escape") setShowSearchBar(false); }}>
                <div className="sm__search-input">
                  <input type="search" placeholder="Search tasks and notes" aria-label="Search tasks and notes" autoFocus
                    value={searchValue} onChange={event => setSearchValue(event.target.value)} />
                  <button type="button" aria-label="Close search" onClick={() => setShowSearchBar(false)}><IoCloseOutline size="1.3em" /></button>
                </div>
                {searchValue.length > 1 && <div className="sm__search-results">
                  {!!matchingTasks.length && <h4>Tasks in this project</h4>}
                  {matchingTasks.map(task => result(task, `/s/${currentSpaceId}/e/${currentStationId}/${view || "b"}/task/${task.id}`))}
                  {!!otherTasks.length && <h4>Your tasks elsewhere</h4>}
                  {otherTasks.map(task => result(task, `/s/${task.fromSpaceId}/e/${task.fromStationId}/b/task/${task.id}`))}
                  {!!matchingNotes.length && <h4>Notes in this project</h4>}
                  {matchingNotes.map(note => result(note, `/s/${currentSpaceId}/e/${currentStationId}/${view || "b"}/note/${note.id}`))}
                  {!matchingTasks.length && !otherTasks.length && !matchingNotes.length && <p>No matching tasks or notes.</p>}
                </div>}
              </div>}
            </div>
            {["b", "l", "c", "g"].includes(view) && <div className="filterbar_container">
              <button type="button" aria-label="Toggle filters" aria-expanded={showFilters}
                className={showFilters ? "sm__filters-toggle-active" : "sm__filters-toggle"}
                onClick={() => { setShowFilters(!showFilters); setShowSearchBar(false); }}>
                {showFilters ? <BsFunnelFill size="1.5em" /> : <BsFunnel size="1.5em" />}
              </button>
              {showFilters && <div className="sm__filters-group"><Filter station={station} /></div>}
            </div>}
          </div>
        </div>
      </div>
    </TopBarRow>
    <div className="sm__buttomRow"><Views view={view} currentStationId={currentStationId} currentSpaceId={currentSpaceId} /></div>
  </div>;
};
export { StationInfo };
export default StationMenu;
